import { AbsoluteFill, Sequence, useCurrentFrame, useVideoConfig } from "remotion";
import { FourierInvader } from "../fourier/FourierInvader";
import { HookFrame } from "./HookFrame";
import type { HookPattern } from "./hookTiming";

/** Editorial teaser, then the unchanged production film (not a phase match). */
export const InvaderHookApplied = ({ pattern = "A" }: { pattern?: HookPattern }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  return (
    <AbsoluteFill style={{ backgroundColor: "#080D18" }}>
      <Sequence from={-39} durationInFrames={600} premountFor={fps}>
        <FourierInvader />
      </Sequence>
      <Sequence durationInFrames={30} premountFor={fps}>
        <AbsoluteFill
          style={{
            opacity: Math.min(1, Math.max(0, (30 - frame) / 6)),
          }}
        >
          <div style={{ transform: "scale(1.5)", transformOrigin: "top left" }}>
            <HookFrame pattern={pattern} frame={frame} />
          </div>
        </AbsoluteFill>
      </Sequence>
    </AbsoluteFill>
  );
};
